module.exports = __webpack_public_path__ + "img/icon-auth-primary.9a41d5be.svg";